export const standardJobDocumentTemplates = [
  {
    name: "OK oder UK totale Prothese",
    code: "SOZ1",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" }, // 2 to 3
      { code_e: "0017.1", quantity: 1, description: "Spezialmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0516.1", quantity: 1, description: "OK oder UK Totalprothese" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "0646.1", quantity: 1, description: "Wachseinprobe umstellen, pro Zahn" }, //0-...
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "OK oder UK totale Immediatprothese",
    code: "SOZ2",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" }, // 2 to 3
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" }, // 0 to 1
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" }, // 0 to 1
      { code_e: "0526.1", quantity: 1, description: "OK oder UK Totalprothese ohne Einprobe" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "OK und UK totale Immediatprothesen",
    code: "SOZ3",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" }, // 2 to 4
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 2, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0052.1", quantity: 2, description: "Bisswall auf Kunststoff" }, // 0 to 2
      { code_e: "0062.1", quantity: 2, description: "Individueller Abformlöffel aus Kunststoff" }, // 0 to 2
      { code_e: "0527.1", quantity: 1, description: "OK und UK Totalprothese ohne Einproben" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "OK oder UK totale Unterfütterung",
    code: "SOZ4",
    job_items: [
      { code_e: "0012.1", quantity: 1, description: "Modell aus Hartgips" },
      { code_e: "0031.1", quantity: 1, description: "Modell in Unterfütterungsgerät" },
      { code_e: "0833.1", quantity: 1, description: "Totalprothese unterfüttern" },
    ]
  },
  {
    name: "Drahtklammerprothese, 4-6 Zähne",
    code: "SOZ5",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" }, // 0 to 1
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" }, // 0 to 1
      { code_e: "0523.1", quantity: 1, description: "4 - 6 Zähne ohne Einprobe" },
      { code_e: "0611.1", quantity: 2, description: "Einfache Drahtklammer" }, // 2 to 4
      { code_e: "0612.1", quantity: 2, description: "Zwei- oder dreiarmige Drahtklammer" }, // 0 to 2
      { code_e: "0621.1", quantity: 1, description: "Vorfabrizierte Verstärkung anpassen und einarbeiten" }, // 0 to 1
      { code_e: "0623.1", quantity: 1, description: "Retention für Einzelzahn" }, // 0 to 2
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2002.0", quantity: 1, description: "Präfabrizierte Bügel oder Netze" },
    ]
  },
  {
    name: "Modellgussprothese OK skelettiert",
    code: "SOZ6",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0017.1", quantity: 1, description: "Spezialmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" }, // 1 to 3
      { code_e: "0046.1", quantity: 1, description: "Modell vermessen" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0312.1", quantity: 1, description: "Modellgussrahmen (skelettierter Rahmen)" },
      { code_e: "0321.1", quantity: 20, description: "Klammerarm / Aufleger / Krallen" },
      { code_e: "0322.1", quantity: 4, description: "Klammeraufgang" },
      { code_e: "0325.1", quantity: 1, description: "Rücken- oder Aufbissplatte" }, // 0 to 2
      { code_e: "0326.1", quantity: 2, description: "Stiftretention, pro Zahn" },
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" },
      { code_e: "0513.1", quantity: 1, description: "4 - 6 Zähne mit Einprobe" },
      { code_e: "0642.1", quantity: 1, description: "Zuschlag zahnfarbig montieren, pro Zahn" }, // 0 to 2
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2003.0", quantity: 1, description: "Legierung" },
    ]
  },
  {
    name: "Modellgussprothese UK, 6 Zähne, 4 Klammern",
    code: "SOZ7",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0017.1", quantity: 1, description: "Spezialmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" }, //1 to 2
      { code_e: "0046.1", quantity: 1, description: "Modell vermessen" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0311.1", quantity: 1, description: "Modellguss Grundform Oberkiefer/Unterkiefer (OK / UK)" },
      { code_e: "0321.1", quantity: 20, description: "Klammerarm / Aufleger / Krallen" },
      { code_e: "0322.1", quantity: 4, description: "Klammeraufgang" },
      { code_e: "0326.1", quantity: 1, description: "Stiftretention, pro Zahn" }, //0 to 4
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" },
      { code_e: "0513.1", quantity: 1, description: "4 - 6 Zähne mit Einprobe" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2003.0", quantity: 1, description: "Legierung" },
    ]
  },
  {
    name: "Modellgussprothese UK, bilateral freiend, 2-4 Klammern",
    code: "SOZ8",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0017.1", quantity: 1, description: "Spezialmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" }, //1 to 2
      { code_e: "0046.1", quantity: 1, description: "Modell vermessen" },
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0311.1", quantity: 1, description: "Modellguss Grundform Oberkiefer/Unterkiefer (OK / UK)" },
      { code_e: "0321.1", quantity: 10, description: "Klammerarm / Aufleger / Krallen" }, // 10 to 20
      { code_e: "0322.1", quantity: 4, description: "Klammeraufgang" }, // 4 to 6
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" },
      { code_e: "0513.1", quantity: 1, description: "4 - 6 Zähne mit Einprobe" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2003.0", quantity: 1, description: "Legierung" },
    ]
  },
  {
    name: "Erweiterung Modellgussprothese um 1 Zahn",
    code: "SOZ9",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" },
      { code_e: "0416.2", quantity: 1, description: "Laserschweissung pro Verbindung" },
      { code_e: "0429.3", quantity: 1, description: "Haftvorbereitung pro Zahn" },
      { code_e: "0642.1", quantity: 1, description: "Zuschlag zahnfarbig montieren, pro Zahn" }, //0 to 1
      { code_e: "0845.1", quantity: 1, description: "Drahtretention exkl. Lötung oder Schweissung" },
      { code_e: "0853.1", quantity: 1, description: "1 Zahn / 1 Klammer montieren" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "Monolithische ZrO2-Krone, Seitenzahn",
    code: "SOZ10",
    job_items: [
      { code_e: "0012.1", quantity: 1, description: "Modell aus Hartgips" },
      { code_e: "0018.1", quantity: 1, description: "Modell zweiteilig zum Sägen" },
      { code_e: "0027.1", quantity: 1, description: "Stumpfmodell Durchschnitt" },
      { code_e: "0028.1", quantity: 1, description: "Herstellung eines zweiten Stumpfes" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0178.1", quantity: 1, description: "Vollkeramikkrone gepresst oder gefräst unbemalt" },
      { code_e: "0185.1", quantity: 1, description: "Krone nachträglich bemalen" },
      { code_e: "2004.0", quantity: 1, description: "Zirkoniumdioxid (ZrO2)" },
    ]
  },
  {
    name: "Monolithische ZrO2-Krone auf Implantat, Seitenzahn",
    code: "SOZ11",
    job_items: [
      { code_e: "0012.1", quantity: 1, description: "Modell aus Hartgips" },
      { code_e: "1001.0", quantity: 1, description: "Meistermodell für Implantat" },
      { code_e: "0026.1", quantity: 1, description: "Platzhalter für Konstruktionsteil in Abdruck reponieren" },
      { code_e: "0027.1", quantity: 1, description: "Stumpfmodell Durchschnitt" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0063.1", quantity: 1, description: "Zahnfleischmaske am Arbeitsmodell" },
      { code_e: "0418.1", quantity: 1, description: "Einkleben eines Hilfteils in Prothese" },
      { code_e: "0429.3", quantity: 1, description: "Haftvorbereitung pro Zahn" },
      { code_e: "1017.0", quantity: 1, description: "Krone auf Implantat aus Porzellan" },
      { code_e: "1027.1", quantity: 1, description: "Verschraubung Konstruktionsteil für Kronen/Brücken auf Implantat, pro Element" },
      { code_e: "0185.1", quantity: 1, description: "Krone nachträglich bemalen" },
      { code_e: "2004.0", quantity: 1, description: "Zirkoniumdioxid (ZrO2)" },
      { code_e: "2006.0", quantity: 1, description: "Implantat-Analog: übrige Elemente" },
      { code_e: "2007.0", quantity: 1, description: "Abutment / Distanzhülse" },
      { code_e: "2008.0", quantity: 1, description: "Abutment-, Distanzhülsenschraube" },
    ]
  },
  {
    name: "Totalprothese mit 2 Implantat-Halteelementen (in situ)",
    code: "SOZ12",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" }, //2 to 3
      { code_e: "0017.1", quantity: 1, description: "Spezialmodell" },
      { code_e: "0026.1", quantity: 2, description: "Platzhalter für Konstruktionsteil in Abdruck reponieren" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" }, //1 to 2
      { code_e: "0052.1", quantity: 1, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 1, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0263.1", quantity: 2, description: "Konstruktionsteil in Metallbasis" },
      { code_e: "0313.1", quantity: 1, description: "Grundgitter und Verstärkungsgerüst" },
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" },
      { code_e: "0516.1", quantity: 1, description: "OK oder UK Totalprothese" },
      { code_e: "0642.1", quantity: 1, description: "Zuschlag zahnfarbig montieren, pro Zahn" }, // 1 to 2
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "0646.1", quantity: 1, description: "Wachseinprobe umstellen, pro Zahn" }, // 0-....
      { code_e: "0648.1", quantity: 2, description: "Zuschlag für Zahnmontage über Konstruktionsteil, pro Zahn" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2003.0", quantity: 1, description: "Legierung" },
      { code_e: "2009.0", quantity: 1, description: "Analoge Halteelemente" },
      { code_e: "2010.0", quantity: 1, description: "Matrizen" },
    ]
  },
  {
    name: "OK und UK totale Prothese",
    code: "SOZ13",
    job_items: [
      { code_e: "0012.1", quantity: 3, description: "Modell aus Hartgips" }, //3 to 4
      { code_e: "0017.1", quantity: 2, description: "Spezialmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 2, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0052.1", quantity: 2, description: "Bisswall auf Kunststoff" },
      { code_e: "0062.1", quantity: 2, description: "Individueller Abformlöffel aus Kunststoff" },
      { code_e: "0517.1", quantity: 1, description: "OK und UK Totalprothese" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "0646.1", quantity: 1, description: "Wachseinprobe umstellen, pro Zahn" }, //0-...
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "Drahtklammerprovisorium 11, 21",
    code: "SOZ14",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0428.1", quantity: 1, description: "Haftvorbereitung, gross" }, //0 to 1
      { code_e: "0522.1", quantity: 1, description: "2-3 Zähne ohne Einprobe" },
      { code_e: "0611.1", quantity: 2, description: "Einfache Drahtklammer" },
      { code_e: "0623.1", quantity: 1, description: "Retention für Einzelzahn" }, //0 to 2
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "OK oder UK Ersatz Seitenzähne",
    code: "SOZ15",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 2, description: "Bissfixierung in Gips oder Silikon herstellen" },
      { code_e: "0815.1", quantity: 2, description: "Einen neuen Zahn montieren" },
      { code_e: "0816.1", quantity: 4, description: "Pro weiteren neuen Zahn oder Klammer" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "OK und UK Ersatz Seitenzähne",
    code: "SOZ16",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 2, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 4, description: "Bissfixierung in Gips oder Silikon herstellen" },
      { code_e: "0815.1", quantity: 4, description: "Einen neuen Zahn montieren" },
      { code_e: "0816.1", quantity: 8, description: "Pro weiteren neuen Zahn oder Klammer" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
    ]
  },
  {
    name: "Michiganschiene, klassisch gestopft",
    code: "SOZ17",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" }, //0 to 2
      { code_e: "0097.1", quantity: 1, description: "Michigan-Aufbissschiene" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
    ]
  },
  {
    name: "Michiganschiene, digital gefräst / gedruckt",
    code: "SOZ18",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0097.1", quantity: 1, description: "Michigan-Aufbissschiene" },
      { code_e: "0645.1", quantity: 1, description: "Prothese, reokkludieren und einschleifen" },
      { code_e: "2011.0", quantity: 1, description: "Kunststoffblank oder 3D-Print-Kunststoff" },
    ]
  },
  {
    name: "Nylonprovisorium 21",
    code: "SOZ19",
    job_items: [
      { code_e: "0001.1", quantity: 2, description: "Taxe, pro 15 Min." }, // 2 to 3
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0013.1", quantity: 1, description: "Duplikatmodell" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0037.1", quantity: 1, description: "Split-Cast mit mechanischer oder magnetischer Befestigung" },
      { code_e: "0038.1", quantity: 1, description: "Bissfixierung in Gips oder Silikon herstellen" },
      { code_e: "0521.1", quantity: 1, description: "1 Zahn ohne Einprobe" },
      { code_e: "2001.0", quantity: 1, description: "Präfabrizierte Zähne" },
      { code_e: "2012.0", quantity: 1, description: "Nylon-Kartusche" },
    ]
  },
  {
    name: "OK Platte mit Frontaufbiss und Protrusionsfedern",
    code: "SOZ20",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0711.1", quantity: 1, description: "Oberkiefer- oder Unterkiefer-Platte" },
      { code_e: "0712.1", quantity: 1, description: "Zuschlag für Frontaufbiss" },
      { code_e: "0721.2", quantity: 1, description: "Labialbogen / Palatinalbogen" },
      { code_e: "0723.1", quantity: 2, description: "Einarmige Klammer, Pfeilklammer" },
      { code_e: "0724.1", quantity: 2, description: "Doppelte Pfeilklammer, Adamsklammer" },
      { code_e: "0725.1", quantity: 4, description: "Protrusionsfeder einfach" },
    ]
  },
  {
    name: "Monoblock nach Zürcher-Modell",
    code: "SOZ21",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0032.1", quantity: 1, description: "Modelle in Mittelwertartikulator oder in einfachen, individuellen Artikulator einstellen" },
      { code_e: "0715.1", quantity: 1, description: "Aktivator oder Monoblock gesägt" },
      { code_e: "0721.2", quantity: 1, description: "Labialbogen / Palatinalbogen" },
      { code_e: "0724.1", quantity: 2, description: "Doppelte Pfeilklammer, Adamsklammer" },
      { code_e: "0726.2", quantity: 1, description: "Protrusionsbogen mit U-Schlaufen oder Helix für Lingualbogen" },
      { code_e: "0734.1", quantity: 1, description: "Head-Gear-Röhrchen setzen (pro Paar)" },
      { code_e: "0735.1", quantity: 1, description: "Coffinfeder (palatinaler Verbindungsbügel)" },
      { code_e: "0764.1", quantity: 1, description: "Head-Gear-Bogen an Aktivator anpassen" },
      { code_e: "2013.0", quantity: 1, description: "Röhrchen" },
      { code_e: "2014.0", quantity: 1, description: "Headgearbogen" },
    ]
  },
  {
    name: "Forcierte Dehnung geklebt mit 2 Bänder",
    code: "SOZ22",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0025.1", quantity: 2, description: "Einzelstumpf oder Band reponieren" },
      { code_e: "0724.2", quantity: 2, description: "Drahtextension" },
      { code_e: "0733.1", quantity: 1, description: "Schraube für forcierte Dehnung anpassen" },
      { code_e: "0753.1", quantity: 6, description: "Schloss, Häkchen, Dorn oder Bracket lasern; pro Verbindung" },
      { code_e: "2015.0", quantity: 1, description: "Dehnschraube" },
    ]
  },
  {
    name: "OK Distalizer oder Mesializer auf Gaumenimplantat",
    code: "SOZ23",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0013.1", quantity: 1, description: "Duplikatmodell" }, // 0 to 1
      { code_e: "0025.1", quantity: 2, description: "Einzelstumpf oder Band reponieren" },
      { code_e: "0026.1", quantity: 1, description: "Platzhalter für Konstruktionsteil in Abdruck reponieren" },
      { code_e: "0725.1", quantity: 4, description: "Protrusionsfeder einfach" },
      { code_e: "0753.1", quantity: 1, description: "Schloss, Häkchen, Dorn oder Bracket lasern; pro Verbindung" }, // 1 to 3
      { code_e: "0755.3", quantity: 1, description: "Verbindungsbügel (gebogen) zu Palatinalimplantat (Gaumenimplantat)" },
      { code_e: "2006.0", quantity: 1, description: "Implantat-Analog: übrige Elemente" },
      { code_e: "2007.0", quantity: 1, description: "Abutment / Distanzhülse" },
      { code_e: "2008.0", quantity: 1, description: "Abutment-, Distanzhülsenschraube" },
      { code_e: "2016.0", quantity: 1, description: "Mobilisator" },
      { code_e: "2017.0", quantity: 1, description: "Feder" },
      { code_e: "2018.0", quantity: 1, description: "Gosh-Schlösser" },
    ]
  },
  {
    name: "OK Distalizer oder Mesializer auf verschiedene Minipin-Systeme",
    code: "SOZ24",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0013.1", quantity: 1, description: "Duplikatmodell" }, // 0 to 1
      { code_e: "0025.1", quantity: 2, description: "Band reponieren" },
      { code_e: "0026.1", quantity: 2, description: "Platzhalter für Konstruktionsteil in Abdruck reponieren" },
      { code_e: "0725.1", quantity: 4, description: "Protrusionsfeder einfach" },
      { code_e: "0753.1", quantity: 1, description: "Schloss, Häkchen, Dorn oder Bracket lasern; pro Verbindung" }, // 1 to 4
      { code_e: "0755.3", quantity: 1, description: "Verbindungsbügel (gebogen) zu Palatinalimplantat (Gaumenimplantat)" },
      { code_e: "2005.0", quantity: 1, description: "Implantat-Analog: diverses Material" },
      { code_e: "2006.0", quantity: 1, description: "Implantat-Analog: übrige Elemente" },
      { code_e: "2007.0", quantity: 1, description: "Abutment / Distanzhülse" },
      { code_e: "2008.0", quantity: 1, description: "Abutment-, Distanzhülsenschraube" },
      { code_e: "2016.0", quantity: 1, description: "Mobilisator" },
      { code_e: "2017.0", quantity: 1, description: "Feder" },
      { code_e: "2018.0", quantity: 1, description: "Gosh-Schlösser" },
    ]
  },
  {
    name: "OK und UK Bracketmasken",
    code: "SOZ25",
    job_items: [
      { code_e: "0012.1", quantity: 2, description: "Modell aus Hartgips" },
      { code_e: "0013.1", quantity: 1, description: "Duplikatmodell" }, // 0 to 2
      { code_e: "0091.1", quantity: 2, description: "Miniplastschiene / Bracketmaske" },
      { code_e: "0768.1", quantity: 4, description: "Bracket setzen" },
      { code_e: "2019.0", quantity: 1, description: "Tiefziehplatte" },
    ]
  }
]
